  /* ----------------------------------------------------------
     Currency display: HKD -> HK, USD -> US, SGD -> S
     (matches the Liquid: "S$38.00" style, no space)
     ---------------------------------------------------------- */
  var CURRENCY_PREFIX = { HKD: 'HK$', USD: 'US$', SGD: 'S$' };

  function fmtPrice(text) {
    if (!text) return text;
    text = String(text).replace(/\s+/g, ' ').trim();

    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var m = text.match(/\b(HKD|USD|SGD)\b/);
    if (m) cur = m[1];

    var prefix = CURRENCY_PREFIX[cur];
    if (!prefix) return text; // other currencies unchanged

    var num = text.match(/\d[\d.,]*/);
    return num ? prefix + num[0] : text;
  }

/* ==========================================================
   Seal subscriptions: sticky widget + main price sync
   ========================================================== */
(function () {

  /* ----------------------------------------------------------
     Helper: run code without the page jumping
     (blocks focus/scrollIntoView scrolling for a moment and
      restores the exact scroll position)
     ---------------------------------------------------------- */
  function withoutScrollJump(fn) {
    var x = window.scrollX;
    var y = window.scrollY;

    var origFocus = HTMLElement.prototype.focus;
    var origScrollIntoView = Element.prototype.scrollIntoView;

    HTMLElement.prototype.focus = function (opts) {
      var o = opts || {};
      o.preventScroll = true;
      return origFocus.call(this, o);
    };
    Element.prototype.scrollIntoView = function () {};

    function restore() {
      if (window.scrollX !== x || window.scrollY !== y) {
        window.scrollTo({ left: x, top: y, behavior: 'instant' });
      }
    }

    try {
      fn();
    } finally {
      restore();
      requestAnimationFrame(restore);
      [50, 150, 300].forEach(function (t) { setTimeout(restore, t); });
      setTimeout(function () {
        HTMLElement.prototype.focus = origFocus;
        Element.prototype.scrollIntoView = origScrollIntoView;
      }, 350);
    }
  }

  /* ----------------------------------------------------------
     1. Sticky add to cart subscription widget
     ---------------------------------------------------------- */
  function initStickySub() {
    var root = document.querySelector('[data-sticky-sub]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var bar = root.closest('sticky-add-to-cart');
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-sticky-sub-data]').textContent); } catch (e) {}

    var select = root.querySelector('[data-sticky-sub-select]');
    var optOnce = root.querySelector('[data-sticky-sub-option="one_time"]');
    var optSub = root.querySelector('[data-sticky-sub-option="subscription"]');
    var oncePriceEl = root.querySelector('[data-sticky-sub-once-price]');
    var subPriceEl = root.querySelector('[data-sticky-sub-sub-price]');
    var atcPriceEl = bar ? bar.querySelector('[ref="stickyAddToCartPrice"]') : null;

    if (!select || !optSub) return;

    var variantId = bar ? String(bar.dataset.currentVariantId) : '';
    var mode = 'subscription';
    var pushing = false;

    function outsideBar(el) { return el && (!bar || !bar.contains(el)); }

    // Main Seal widget on the page (not inside the sticky bar)
    function getMainWidget() {
      var all = document.querySelectorAll('.sealsubs-container');
      for (var i = 0; i < all.length; i++) if (outsideBar(all[i])) return all[i];
      return null;
    }

    // Main product form
    function getMainForm() {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (outsideBar(forms[i]) && forms[i].querySelector('[name="id"]')) return forms[i];
      }
      return null;
    }

    function render() {
      var v = data[variantId] || {};
      var plan = (v.plans && v.plans[select.value]) || null;

      if (optOnce) {
        optOnce.classList.toggle('is-active', mode === 'one_time');
        optOnce.setAttribute('aria-checked', mode === 'one_time' ? 'true' : 'false');
      }
      optSub.classList.toggle('is-active', mode === 'subscription');
      optSub.setAttribute('aria-checked', mode === 'subscription' ? 'true' : 'false');

            if (oncePriceEl && v.label) oncePriceEl.textContent = fmtPrice(v.label);
      if (subPriceEl) subPriceEl.textContent = fmtPrice(plan ? plan.label : (v.label || subPriceEl.textContent));

      if (atcPriceEl) {
        var p = mode === 'subscription' && plan ? plan.price : v.price;
        if (p) atcPriceEl.textContent = fmtPrice(p);
      }
    }

    // Sticky -> main Seal widget + product form (without moving the page)
    function pushToMain() {
      pushing = true;

      withoutScrollJump(function () {
        var w = getMainWidget();
        if (w) {
          var radio = w.querySelector(
            mode === 'one_time'
              ? '[data-one-time-option-radio] [role="radio"]'
              : '[data-selling-plan-group-option-radio] [role="radio"]'
          );
          if (radio && radio.getAttribute('aria-checked') !== 'true') radio.click();

          if (mode === 'subscription') {
            var mainSelect = w.querySelector('select[name="subs_interval"]');
            if (mainSelect && mainSelect.value !== select.value) {
              mainSelect.value = select.value;
              mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }

        var form = getMainForm();
        if (form) {
          var input = form.querySelector('input[name="selling_plan"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            form.appendChild(input);
          }
          input.value = mode === 'subscription' ? select.value : '';
        }
      });

      setTimeout(function () {
        pushing = false;
        render();
      }, 150);
    }

    // Main Seal widget -> sticky
    function pullFromMain() {
      if (pushing) return;
      var w = getMainWidget();
      if (!w) return;

      var active = w.querySelector('.sls-option-container.sls-active');
      mode = active && active.hasAttribute('data-selling-plan-group') ? 'subscription' : 'one_time';

      var mainSelect = w.querySelector('select[name="subs_interval"]');
      if (mainSelect && select.querySelector('option[value="' + mainSelect.value + '"]')) {
        select.value = mainSelect.value;
      }
      render();
    }

    function bindMain() {
      var w = getMainWidget();
      if (!w) return false;
      if (w.dataset.stickyBound !== 'true') {
        w.dataset.stickyBound = 'true';
        new MutationObserver(pullFromMain).observe(w, { attributes: true, attributeFilter: ['class'], subtree: true });
        w.addEventListener('change', function () { setTimeout(pullFromMain, 0); });
        pullFromMain();
      }
      return true;
    }

    function setMode(newMode) {
      mode = newMode;
      render();
      pushToMain();
    }

    if (optOnce) optOnce.addEventListener('click', function () { setMode('one_time'); });
    optSub.addEventListener('click', function () { if (mode !== 'subscription') setMode('subscription'); });
    select.addEventListener('change', function () { setMode('subscription'); });

    [optOnce, optSub].forEach(function (el) {
      if (!el) return;
      el.addEventListener('keydown', function (e) {
        if (e.target === el && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          el.click();
        }
      });
    });

    // Variant changes (Horizon fires "variant:update")
    document.addEventListener('variant:update', function (e) {
      var resource = e.detail && e.detail.resource;
      if (resource && resource.id) variantId = String(resource.id);
      render();
      setTimeout(bindMain, 300); // Seal may re-render its widget
    });

    render();

    // Seal renders its widget after load, so wait for it
    var tries = 0;
    (function waitForMain() {
      if (bindMain()) return;
      if (++tries < 40) setTimeout(waitForMain, 250);
      else pushToMain(); // No Seal widget found: set the form directly
    })();
  }

  /* ----------------------------------------------------------
     2. Main Add to cart price sync with the Seal widget
     ---------------------------------------------------------- */
  var priceTries = 0;

  function getSealRoot() {
    var all = document.querySelectorAll('.sealsubs-target-element');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('sticky-add-to-cart')) return all[i];
    }
    return null;
  }

  function initSealPriceSync() {
    var sealRoot = getSealRoot();
    var priceTarget = document.querySelector('[ref="addToCartPrice"]');

    // Seal renders after page load, so wait for it (up to ~10s)
    if (!sealRoot || !priceTarget) {
      if (++priceTries < 40) setTimeout(initSealPriceSync, 250);
      return;
    }
    if (sealRoot.dataset.priceSyncBound === 'true') return;
    sealRoot.dataset.priceSyncBound = 'true';

        function formatSealPrices() {
      sealRoot.querySelectorAll('.money').forEach(function (el) {
        if (el.children.length) return;
        var next = fmtPrice(el.textContent);
        if (next && next !== el.textContent) el.textContent = next;
      });
    }

    var fmtQueued = false;
    new MutationObserver(function () {
      if (fmtQueued) return;
      fmtQueued = true;
      requestAnimationFrame(function () {
        fmtQueued = false;
        formatSealPrices();
      });
    }).observe(sealRoot, { childList: true, subtree: true, characterData: true });

    formatSealPrices();

    var basePriceText = priceTarget.dataset.basePriceText || priceTarget.textContent.trim();

    function syncPrice() {
      var activeOption = sealRoot.querySelector('.seal-table.sls-active, .sls-option-container.sls-active');
      if (!activeOption) {
                var baseFmt = fmtPrice(basePriceText);
        if (priceTarget.textContent !== baseFmt) priceTarget.textContent = baseFmt;
        return;
      }

      var priceEl = activeOption.querySelector('.sls-total-price .money, .sls-price-container .money');
      var text = priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '';
       var next = fmtPrice(text || basePriceText);

      // Only write when the text changes
      if (priceTarget.textContent !== next) priceTarget.textContent = next;
    }

    // Radio / interval changes (Seal updates prices slightly after)
    sealRoot.addEventListener('change', function () { setTimeout(syncPrice, 50); });
    sealRoot.addEventListener('click', function () { setTimeout(syncPrice, 50); });

    // Catch any other price updates Seal makes
    new MutationObserver(syncPrice).observe(sealRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    syncPrice();
  }

  // Seal may re-render its widget after a variant change
  document.addEventListener('variant:update', function () {
    priceTries = 0;
    setTimeout(initSealPriceSync, 300);
  });

  /* ----------------------------------------------------------
     Start
     ---------------------------------------------------------- */
  function start() {
    initStickySub();
    initSealPriceSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();